import React from 'react';
import './styles/animations.css';

import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Aerveil from './components/Aerveil';
import Experience from './components/Experience';
import SelectedWork from './components/SelectedWork';
import Publications from './components/Publications';
import AerveilFilm from './components/AerveilFilm';
import Contact from './components/Contact';
import SectionRail from './components/SectionRail';

function App() {
  return (
    <div className="relative min-h-screen bg-cream text-ink">
      <Navigation />
      <SectionRail />

      <main className="relative">
        <Hero />
        <Aerveil />
        <Experience />
        <SelectedWork />
        <Publications />
        <AerveilFilm />
        <Contact />
      </main>
    </div>
  );
}

export default App;
